export type CookieConsent = {
  necessary: boolean;
  analytics: boolean;
  timestamp: number;
};

const CONSENT_STORAGE_KEY = "ximly_cookie_consent";
export const CONSENT_CHANGED_EVENT = "ximly:consent-changed";

export function setCookieConsent(consent: CookieConsent) {
  try {
    const value = JSON.stringify(consent);
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
    // Notify current tab listeners immediately (storage event won't fire in same document)
    try {
      window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: consent }));
    } catch {}
  } catch {}
}

export function getCookieConsent(): CookieConsent | null {
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      typeof parsed === "object" &&
      parsed !== null &&
      typeof parsed.necessary === "boolean" &&
      typeof parsed.analytics === "boolean"
    ) {
      return parsed as CookieConsent;
    }
  } catch {}
  return null;
}

export function hasConsentedToAnalytics(): boolean {
  const consent = getCookieConsent();
  return !!consent?.analytics;
}

export function consentCookieName(): string {
  return CONSENT_STORAGE_KEY;
}


